import store from '@/store'
export default [
  {
    path: '/notification-monitoring',
    name: 'notification-monitoring',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-monitoring/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('notificationMonitoring/dataBeforeCreate')
      next()
    }
  }
]
